(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-promo-field"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-cart-promo-field')) {
  customElements.define('pp-cart-promo-field', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.pp-cart-hybrid');
      this.input = this.querySelector('input');
      this.applyButton = this.querySelector('[data-pp-promo-apply]');
      this.status = this.querySelector('[role="status"]');
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      this.applyButton.addEventListener('click', () => this.apply(), options);
      this.input.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || event.isComposing) return;
        event.preventDefault();
        event.stopPropagation();
        this.apply();
      }, options);
      this.root.addEventListener('click', (event) => {
        const remove = event.target.closest('cart-discount-remove-button');
        if (!remove) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.apply(remove.getAttribute('discount-code'));
      }, { ...options, capture: true });
      this.root.addEventListener('submit', (event) => {
        if (!this.busy) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, { ...options, capture: true });
    }

    disconnectedCallback() {
      this.listeners?.abort();
    }

    codes(cart, applicableOnly = false) {
      const codes = new Map();
      for (const entry of cart.discount_codes || []) {
        if (entry.code && (!applicableOnly || entry.applicable === true)) codes.set(entry.code.toUpperCase(), entry.code);
      }
      const applications = [...(cart.cart_level_discount_applications || [])];
      for (const item of cart.items || []) {
        for (const allocation of item.line_level_discount_allocations || []) applications.push(allocation.discount_application);
      }
      for (const entry of applications) {
        if (entry?.type === 'discount_code' && entry.title) codes.set(entry.title.toUpperCase(), entry.title);
      }
      return [...codes.values()];
    }

    message(text, error = false) {
      this.status.textContent = text;
      this.status.toggleAttribute('data-error', error);
      this.input.setAttribute('aria-invalid', String(error));
    }

    setBusy(busy) {
      this.busy = busy;
      this.setAttribute('aria-busy', String(busy));
      this.root.toggleAttribute('data-pp-discount-busy', busy);
      if (busy) {
        this.controls = [...this.root.querySelectorAll('button,input,textarea')].map(element => [element, element.disabled]);
        for (const [element] of this.controls) element.disabled = true;
      } else {
        for (const [element, disabled] of this.controls || []) element.disabled = disabled;
      }
    }

    async apply(removeCode = null) {
      if (this.busy) return;
      const code = removeCode === null ? this.input.value.trim() : removeCode;
      if (!code) {
        this.message(this.dataset.empty, true);
        this.input.focus();
        return;
      }
      this.message(this.dataset.loading);
      this.setBusy(true);
      const request = new AbortController();
      const timer = setTimeout(() => request.abort(), 25000);
      const cartUrl = this.dataset.cartUrl;
      const drawerSection = document.querySelector('cart-drawer')?.closest('.shopify-section');
      const drawerSectionId = drawerSection?.id.replace(/^shopify-section-/, '');
      const sections = [...new Set([this.dataset.sectionId, drawerSectionId].filter(Boolean))];
      try {
        const currentResponse = await fetch(`${cartUrl}.js`, { credentials: 'same-origin', cache: 'no-store', signal: request.signal });
        if (!currentResponse.ok) throw new Error('cart-read');
        const current = await currentResponse.json();
        const existing = this.codes(current);
        const same = entry => entry.toUpperCase() === code.toUpperCase();
        if (removeCode === null && this.codes(current, true).some(same)) {
          this.message(this.dataset.already);
          return;
        }
        const codes = existing.filter(entry => !same(entry));
        if (removeCode === null) codes.push(code);
        const response = await fetch(`${cartUrl}/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          signal: request.signal,
          body: JSON.stringify({ discount: codes.join(','), sections, sections_url: cartUrl })
        });
        if (!response.ok) throw new Error('cart-update');
        const updated = await response.json();
        const accepted = this.codes(updated, true).some(same);
        const success = removeCode !== null ? !this.codes(updated).some(same) : accepted;
        const message = success ? (removeCode !== null ? this.dataset.removed : this.dataset.success) : this.dataset.invalid;
        const html = updated.sections?.[this.dataset.sectionId];
        const nextRoot = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('.pp-cart-hybrid') : null;
        const drawerHtml = drawerSectionId ? updated.sections?.[drawerSectionId] : null;
        const nextDrawer = drawerHtml ? new DOMParser().parseFromString(drawerHtml, 'text/html').getElementById(drawerSection.id) : null;
        if (!nextRoot || !nextRoot.querySelector('pp-cart-promo-field') || (drawerSection && !nextDrawer)) {
          window.location.reload();
          return;
        }
        this.setBusy(false);
        if (drawerSection && nextDrawer) drawerSection.replaceWith(nextDrawer);
        this.root.replaceWith(nextRoot);
        const next = nextRoot.querySelector('pp-cart-promo-field');
        next.closest('details').open = true;
        next.message(message, !success);
        if (!success && removeCode === null) next.input.value = code;
        next.applyButton.focus({ preventScroll: true });
      } catch (error) {
        if (this.isConnected) this.message(this.dataset.error, true);
      } finally {
        clearTimeout(timer);
        if (this.isConnected) this.setBusy(false);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-custom-crop"] && !Shopify.designMode) return;
  try {
    (function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.PPCropCore = factory();
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  const PREVIEW_MAX = 2048;
  const UUID = /^[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}$/i;
  function ratio(value) {
    const m = /^(\d+):(\d+)$/.exec(value);
    if (!m || +m[1] < 1 || +m[2] < 1) throw new Error('Invalid crop ratio');
    let a = +m[1], b = +m[2], x = a, y = b;
    while (y) [x, y] = [y, x % y];
    return { a: a / x, b: b / x, value: a / b, text: `${a / x}:${b / x}` };
  }
  function key(ratios) { return [...new Set(ratios.map(v => ratio(v).text))].sort().join(','); }
  function metadataValidators(validators) {
    return validators.map(validate => info => {
      if (info.name == null && info.isImage == null) return;
      return validate(info);
    });
  }
  function settings(ratios, portrait) {
    return [...new Set(ratios.map(v => ratio(v).text))].sort((a, b) => portrait ? ratio(a).value - ratio(b).value : ratio(b).value - ratio(a).value).join(',');
  }
  function scaledAspect(size, scale) {
    if (!Array.isArray(size) || size.length !== 2 || !Array.isArray(scale) || scale.length !== 2 || [...size, ...scale].some(value => !Number.isFinite(value) || value <= 0)) return null;
    const corrected = size[0] / size[1] * scale[1] / scale[0];
    return Number.isFinite(corrected) && corrected > 0 ? corrected : null;
  }
  function scaleCropHook(original, active, report) {
    return function (settings) {
      const result = original.call(this, settings);
      if (!active(this, settings)) return result;
      const scale = this.__api?.getScaleFactor?.();
      const corrected = scaledAspect(settings?.preferedSize, scale);
      if (corrected === null || typeof this.__api?.setOptions !== 'function') return result;
      this.__api.setOptions({ aspectRatio: corrected });
      report?.({ scale, corrected, size: [...settings.preferedSize] });
      return result;
    };
  }
  function crop(info, ratios) {
    if (!info || !UUID.test(info.uuid || '') || info.isImage !== true) throw new Error('An image is required');
    const url = new URL(info.cdnUrl);
    if (url.protocol !== 'https:' || !/(^|\.)ucarecd\.net$|(^|\.)ucarecdn\.com$/i.test(url.hostname) || url.pathname.split('/')[1] !== info.uuid) throw new Error('Invalid crop source');
    const chunks = url.pathname.split('/-/');
    const operations = chunks.slice(1).filter(Boolean);
    if (operations.some(p => !/^(crop|preview|resize|quality|format)\//.test(p))) throw new Error('Unsupported image operation');
    const crops = operations.filter(p => p.startsWith('crop/'));
    if (crops.length > 1 || operations.some(p => /^(resize|preview)\/\d/.test(p))) throw new Error('A full resolution crop is required');
    const original = info.originalImageInfo;
    const m = crops.length ? /^crop\/(\d+)x(\d+)\/(\d+),(\d+)\/?$/.exec(crops[0]) : original && [null, original.width, original.height, 0, 0];
    if (!m) throw new Error('Invalid crop coordinates');
    const [width, height, left, top] = m.slice(1).map(Number);
    if (!width || !height || !original || left + width > original.width + 1 || top + height > original.height + 1) throw new Error('Crop outside original image');
    const match = ratios.map(ratio).find(r => Math.abs(width / height / r.value - 1) <= 0.002);
    if (!match) throw new Error('Crop does not match selected size');
    const originalUrl = `${url.origin}/${info.uuid}/`;
    const cropReference = `${originalUrl}-/crop/${width}x${height}/${left},${top}/`;
    const printReference = `${cropReference}-/quality/best/-/format/jpeg/`;
    return { uuid: info.uuid, width, height, left, top, originalWidth: original.width, originalHeight: original.height, ratio: match.text, name: info.name || '', originalUrl, printReference, previewUrl: `${cropReference}-/preview/${PREVIEW_MAX}x${PREVIEW_MAX}/-/quality/normal/-/format/jpeg/` };
  }
  function verifyFiles(accepted, source, rendered) {
    if (source.uuid !== accepted.uuid || source.is_image !== true || source.is_ready !== true || source.is_stored !== true || !Number.isSafeInteger(source.size) || source.size < 1) throw new Error('Original storage is not confirmed');
    if (source.image_info?.width !== accepted.originalWidth || source.image_info?.height !== accepted.originalHeight) throw new Error('Original dimensions changed');
    if (rendered.original?.id !== accepted.uuid || rendered.width !== accepted.width || rendered.height !== accepted.height || rendered.id !== new URL(accepted.printReference).pathname) throw new Error('Print file does not match confirmed crop');
    return Object.freeze({ printReference: accepted.printReference, originalUrl: accepted.originalUrl, uuid: accepted.uuid, sourceBytes: source.size, stored: true });
  }
  const publicFileKey = 'Your upload (file we will be printing)';
  function orderSnapshot(accepted, selection, proof) {
    if (!accepted || !selection || accepted.selection.id !== selection.id || accepted.key !== key(selection.ratios) || proof?.stored !== true || proof.printReference !== accepted.printReference || proof.uuid !== accepted.uuid) throw new Error('Files are not verified for this selection');
    const properties = Object.freeze({
      [publicFileKey]: accepted.printReference,
      _pp_crop_version: '1',
      _pp_original_file: accepted.originalUrl,
      _pp_original_name: accepted.name,
      _pp_original_bytes: String(proof.sourceBytes),
      _pp_original_stored: 'true',
      _pp_source_uuid: accepted.uuid,
      _pp_print_crop: accepted.printReference,
      _pp_crop_preview: accepted.previewUrl,
      _pp_crop_pixels: `${accepted.width}x${accepted.height}`,
      _pp_crop_rect: `${accepted.width},${accepted.height},${accepted.left},${accepted.top}`,
      _pp_crop_ratio: accepted.ratio,
      _pp_crop_variant: String(selection.id)
    });
    return Object.freeze({ variant: String(selection.id), properties });
  }
  function writeOrderData(data, fieldName, snapshot, allowed) {
    for (const name of [...data.keys()]) {
      if (name === `properties[${fieldName}]` || name.startsWith(`properties[_${fieldName} `) || name.startsWith('properties[_pp_') || name === `properties[${publicFileKey}]`) data.delete(name);
    }
    if (!allowed) { data.delete('id'); return; }
    if (!snapshot) return;
    if (String(data.get('id')) !== snapshot.variant) { data.delete('id'); return; }
    Object.entries(snapshot.properties).forEach(([name, value]) => data.set(`properties[${name}]`, value));
  }
  function createSession() {
    let selection = null, accepted = null, pending = null, sequence = 0, status = 'empty';
    function select(next) {
      if (!next || !next.id || !next.ratios?.length) { selection = null; pending = null; sequence++; status = 'unknown-size'; return status; }
      selection = { ...next, key: key(next.ratios) };
      if (pending && pending.selection.id !== selection.id) { pending = null; sequence++; }
      status = pending ? 'cropping' : accepted ? accepted.key === selection.key ? 'ready' : 'needs-crop' : 'empty';
      if (status === 'ready') accepted.selection = { ...selection };
      return status;
    }
    function begin() {
      if (!selection) throw new Error('Select a valid size');
      pending = { token: ++sequence, selection: { ...selection } };
      status = 'cropping';
      return pending;
    }
    function accept(token, info) {
      if (!pending || token !== pending.token || pending.selection.id !== selection?.id) return null;
      const result = crop(info, selection.ratios);
      accepted = { ...result, key: selection.key, selection: { ...selection } };
      pending = null;
      status = 'ready';
      return accepted;
    }
    function cancel(token) {
      if (!pending || token !== pending.token) return null;
      pending = null;
      sequence++;
      const restore = accepted?.selection || null;
      if (restore) selection = { ...restore };
      status = accepted ? 'ready' : 'empty';
      return restore;
    }
    function clear() { accepted = null; pending = null; sequence++; status = selection ? 'empty' : 'unknown-size'; }
    function fail() { pending = null; sequence++; status = 'error'; }
    function recover(next) {
      if (pending || !accepted || !next || next.id !== selection?.id || accepted.key !== key(next.ratios)) return false;
      selection = { ...next, key: key(next.ratios) };
      accepted.selection = { ...selection };
      status = 'ready';
      return true;
    }
    return { select, begin, accept, cancel, clear, fail, recover, get snapshot() { return { selection, accepted, pending, status, canSubmit: status === 'empty' || status === 'ready' }; } };
  }
  return { PREVIEW_MAX, ratio, key, settings, scaledAspect, scaleCropHook, crop, createSession, metadataValidators, verifyFiles, orderSnapshot, writeOrderData };
});

(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else root.PPCropOrientation = factory(root);
})(typeof window !== 'undefined' ? window : this, function (env) {
  'use strict';
  function watch(dialog, options) {
    const collection = dialog?.fileColl;
    if (!collection?.onAdd?.add || !collection?.onRemove?.add || typeof collection.get !== 'function' || typeof dialog.always !== 'function') return () => {};
    const ratios = options.ratios.map(text => ({text, value: Number(text.split(':')[0]) / Number(text.split(':')[1])}));
    let closed = false, current = null, stopPending = () => {};
    const watched = new WeakSet();
    const report = (state, detail = {}) => options.report?.(state, detail);
    function added(file) {
      stopPending();
      current = file;
      if (!file || typeof file.done !== 'function' || watched.has(file)) return;
      watched.add(file);
      let stopped = false, observer, root, expiry, bootstrap, info;
      const cancel = reason => {
        if (stopped) return;
        stopped = true;
        observer?.disconnect();
        if (root) {
          ['pointerdown', 'keydown', 'click'].forEach(name => root.removeEventListener(name, touched, true));
          root.removeEventListener('load', attempt, true);
        }
        env.clearTimeout(expiry);
        env.clearTimeout(bootstrap);
        report(reason);
      };
      const touched = event => {
        if (event.isTrusted && event.target?.closest?.('.uploadcare--crop-sizes, .uploadcare--preview__content_crop, .uploadcare--preview__done')) cancel('manual-choice');
      };
      function attempt() {
        if (closed || stopped || current !== file || !info || !root) return;
        const dimensions = info.originalImageInfo;
        if (!info.isImage || !(dimensions?.width > 0 && dimensions?.height > 0)) return cancel('no-dimensions');
        if (info.uuid === options.retainedUuid) return cancel('retained-choice');
        if (info.crop || /(?:^|\/-\/)crop\//.test(info.cdnUrlModifiers || info.cdnUrl || '')) return cancel('existing-crop');
        const preview = root.querySelector('.uploadcare--preview__image');
        if (!preview?.complete || !(preview.naturalWidth > 0 && preview.naturalHeight > 0)) return;
        const previewSource = preview.currentSrc || preview.src || '';
        if (/^https?:/.test(previewSource) && info.uuid && !previewSource.includes(info.uuid)) return;
        const portrait = preview.naturalHeight > preview.naturalWidth;
        if (preview.naturalHeight === preview.naturalWidth) return cancel('square-default');
        const choice = ratios.find(r => portrait ? r.value < 1 : r.value > 1);
        if (!choice || !/^[1-9]\d*:[1-9]\d*$/.test(choice.text)) return cancel('no-matching-preset');
        const preset = root.querySelector('.uploadcare--crop-sizes__item[data-caption="' + choice.text + '"]');
        if (!preset || preset.getAttribute('aria-disabled') !== 'false') return;
        const detail = {orientation: portrait ? 'portrait' : 'landscape', ratio: choice.text, sourceSize: dimensions.width + 'x' + dimensions.height};
        if (preset.classList.contains('uploadcare--crop-sizes__item_current')) {
          report('matched', detail);
          return cancel('already-matched');
        }
        const cropper = env.ph_jcrop;
        const holder = cropper?.ui?.holder?.[0];
        if (!holder || !root.contains(holder) || typeof cropper.getBounds !== 'function' || typeof cropper.setSelect !== 'function') return cancel('manual-fallback');
        const bounds = cropper.getBounds();
        if (!Array.isArray(bounds) || bounds.length !== 2 || !bounds.every(v => Number.isFinite(v) && v > 0)) return cancel('manual-fallback');
        const width = Math.min(bounds[0], bounds[1] * choice.value);
        const height = width / choice.value;
        const left = (bounds[0] - width) / 2;
        const top = (bounds[1] - height) / 2;
        try {
          preset.click();
          if (!preset.classList.contains('uploadcare--crop-sizes__item_current')) return cancel('manual-fallback');
          cropper.setSelect([left, top, left + width, top + height]);
          report('matched', detail);
          cancel('selected');
        } catch (_) { cancel('manual-fallback'); }
      }
      function bind(count = 0) {
        if (closed || stopped || current !== file) return;
        root = env.document.querySelector('.uploadcare--dialog_status_active:not(.uploadcare--dialog_status_inactive)');
        if (!root) {
          if (count < 20) bootstrap = env.setTimeout(() => bind(count + 1), 50);
          else cancel('dialog-unavailable');
          return;
        }
        ['pointerdown', 'keydown', 'click'].forEach(name => root.addEventListener(name, touched, true));
        root.addEventListener('load', attempt, true);
        observer = new env.MutationObserver(attempt);
        observer.observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['aria-disabled', 'src']});
        attempt();
      }
      stopPending = () => cancel('stopped');
      report('waiting-metadata');
      bind();
      file.done(value => {
        if (closed || stopped || current !== file) return;
        info = value;
        report('waiting-crop');
        expiry = env.setTimeout(() => cancel('manual-fallback'), 15000);
        attempt();
      });
      file.fail?.(() => cancel('upload-failed'));
    }
    const removed = file => {
      if (file === current) { stopPending(); current = null; }
    };
    const close = () => {
      if (closed) return;
      closed = true;
      stopPending();
      collection.onAdd.remove(added);
      collection.onRemove.remove(removed);
    };
    collection.onAdd.add(added);
    collection.onRemove.add(removed);
    dialog.always(close);
    for (const file of collection.get()) added(file);
    return close;
  }
  return {watch};
});

(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else root.PPCropCancel = factory(root);
})(typeof window !== 'undefined' ? window : this, function (env) {
  'use strict';
  const selector = 'button.uploadcare--preview__back.uploadcare-tab-effects--cancel';
  function watch(dialog) {
    if (typeof dialog?.reject !== 'function' || typeof dialog.always !== 'function') return () => {};
    let closed = false, cancelling = false, root, observer, timer;
    const buttons = new Map();
    function refresh() {
      if (closed || cancelling || !root) return;
      root.querySelectorAll(selector).forEach(button => {
        if (!buttons.has(button)) buttons.set(button, {disabled: button.disabled, aria: button.getAttribute('aria-disabled')});
        if (button.disabled) button.disabled = false;
        if (button.hasAttribute('aria-disabled')) button.removeAttribute('aria-disabled');
      });
    }
    function cancel(event) {
      const button = event.target?.closest?.(selector);
      if (closed || cancelling || !button || !root.contains(button) || !buttons.has(button)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      cancelling = true;
      try { dialog.reject(); }
      catch (_) { cancelling = false; }
    }
    function close() {
      if (closed) return;
      closed = true;
      env.clearTimeout(timer);
      observer?.disconnect();
      root?.removeEventListener('click', cancel, true);
      buttons.forEach((state, button) => {
        button.disabled = state.disabled;
        if (state.aria === null) button.removeAttribute('aria-disabled');
        else button.setAttribute('aria-disabled', state.aria);
      });
      buttons.clear();
    }
    function bind(attempt = 0) {
      if (closed) return;
      root = env.document.querySelector('.uploadcare--dialog_status_active:not(.uploadcare--dialog_status_inactive)');
      if (!root) {
        if (attempt < 20) timer = env.setTimeout(() => bind(attempt + 1), 50);
        return;
      }
      root.addEventListener('click', cancel, true);
      observer = new env.MutationObserver(refresh);
      observer.observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled']});
      refresh();
    }
    dialog.always(close);
    bind();
    return close;
  }
  return {watch};
});

(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else root.PPCropRecovery = factory(root);
})(typeof window !== 'undefined' ? window : this, function (env) {
  'use strict';
  function error(code, retryable = false) { return Object.assign(new Error(code), { code, retryable }); }
  function aborted() { return error('cancelled'); }
  function wait(ms, signal) {
    return new Promise((resolve, reject) => {
      if (signal?.aborted) return reject(aborted());
      let timer;
      const finish = failure => { env.clearTimeout(timer); signal?.removeEventListener('abort', stop); failure ? reject(failure) : resolve(); };
      const stop = () => finish(aborted());
      signal?.addEventListener('abort', stop, { once: true });
      timer = env.setTimeout(() => finish(), ms);
    });
  }
  function deadline(task, ms, signal) {
    return new Promise((resolve, reject) => {
      if (signal?.aborted) return reject(aborted());
      const controller = new env.AbortController();
      let settled = false, timer;
      const finish = (failure, result) => {
        if (settled) return;
        settled = true;
        env.clearTimeout(timer);
        signal?.removeEventListener('abort', stop);
        controller.abort();
        failure ? reject(failure) : resolve(result);
      };
      const stop = () => finish(aborted());
      signal?.addEventListener('abort', stop, { once: true });
      timer = env.setTimeout(() => finish(error('timeout', true)), ms);
      Promise.resolve().then(() => task(controller.signal)).then(result => finish(null, result), failure => finish(failure));
    });
  }
  async function retry(task, options = {}) {
    const delays = options.delays || [0, 1000, 2500, 5000, 10000];
    const expires = Date.now() + (options.budget || 60000);
    let last;
    for (let index = 0; index < delays.length; index++) {
      if (options.signal?.aborted) throw aborted();
      if (index) {
        if (Date.now() + delays[index] >= expires) break;
        options.onRetry?.(index, last);
        await wait(delays[index], options.signal);
      }
      const remaining = expires - Date.now();
      if (remaining <= 0) break;
      try { return await deadline(task, Math.min(options.timeout || 12000, remaining), options.signal); }
      catch (failure) {
        if (options.signal?.aborted) throw aborted();
        if (!failure.retryable) throw failure;
        last = failure;
      }
    }
    throw last || error('timeout', true);
  }
  function image(url, signal, maximum) {
    return new Promise((resolve, reject) => {
      if (signal?.aborted) return reject(aborted());
      const img = new env.Image();
      const finish = failure => {
        img.onload = img.onerror = null;
        signal?.removeEventListener('abort', stop);
        failure ? reject(failure) : resolve({ width: img.naturalWidth, height: img.naturalHeight });
      };
      const stop = () => { finish(aborted()); img.removeAttribute('src'); };
      signal?.addEventListener('abort', stop, { once: true });
      img.crossOrigin = 'anonymous';
      img.onload = () => finish(img.naturalWidth > maximum || img.naturalHeight > maximum || img.naturalWidth < 1 || img.naturalHeight < 1 ? error('preview-dimensions') : null);
      img.onerror = () => finish(error('preview-load', true));
      img.src = url;
    });
  }
  return { error, wait, deadline, retry, image };
});

(() => {
  'use strict';
  const marker = document.getElementById('pp-uploadly-custom-pilot');
  if (!marker || marker.dataset.initialized) return;
  marker.dataset.initialized = 'true';
  const cfg = JSON.parse(document.getElementById('pp-custom-crop-config').textContent);
  const core = window.PPCropCore;
  const recovery = window.PPCropRecovery;
  const session = core.createSession();
  const main = document.querySelector('.shopify-section--main-product');
  const controller = new AbortController();
  const signal = controller.signal;
  const status = document.getElementById('pp-custom-crop-status');
  const retry = document.getElementById('pp-custom-crop-retry');
  const timerIds = new Set();
  let widget, field, form, api, savedFile, originalMethod, prototype, hook;
  let cropPrototype, originalSetCrop, cropScaleHook;
  let destroyed = false, paused = false, suspended = false, variantBusy = false, verified = false, mounted = false;
  let previewSequence = 0, dialogActive = false, properties = [];
  let closeOrientation = () => {};
  let closeCancel = () => {};
  let closeHelp = () => {};
  let closePolish = () => {};
  let fileProof = null, fileCheck = null, fileSequence = 0;
  let previewCheck = null, failurePhase = '', working = false, resumeUpload = null;
  marker.dataset.bridgeVersion = 'recovery-2-scale';
  const later = (fn, ms) => {
    const id = setTimeout(() => { timerIds.delete(id); if (!destroyed) fn(); }, ms);
    timerIds.add(id);
    return id;
  };
  const nativeInputs = () => [...document.querySelectorAll('input[name^="properties["]')].filter(input => input.form === form && input.name.includes(cfg.fieldName));
  function record(event, detail = '') {
    const events = JSON.parse(marker.dataset.events || '[]');
    events.push({ event, detail, at: Date.now() });
    marker.dataset.events = JSON.stringify(events.slice(-15));
  }
  function render(message) {
    const state = session.snapshot;
    const blocked = paused || working || !mounted || variantBusy || !state.canSubmit || (state.accepted && !verified);
    marker.dataset.state = state.status;
    marker.dataset.cartBlocked = String(Boolean(blocked));
    marker.dataset.selectedSize = state.selection?.size || '';
    marker.dataset.ratios = state.selection?.ratios.join(',') || '';
    marker.dataset.cropSource = state.accepted?.printReference || '';
    marker.dataset.filename = state.accepted?.name || '';
    marker.dataset.sourceUuid = state.accepted?.uuid || '';
    marker.dataset.originalBytes = fileProof && state.accepted && fileProof.uuid === state.accepted.uuid && fileProof.printReference === state.accepted.printReference ? String(fileProof.sourceBytes) : '';
    marker.dataset.cropSize = state.accepted ? `${state.accepted.width}x${state.accepted.height}` : '';
    status.textContent = message || (state.accepted && state.status === 'ready' && !verified ? cfg.words.verifying : cfg.words[state.status]) || cfg.words.waiting;
    retry.hidden = !widget || dialogActive || working || !(state.status === 'error' || (verified && state.accepted));
    retry.textContent = state.status === 'error' ? (failurePhase === 'crop' ? cfg.words.retry : cfg.words.retry_check) : cfg.words.reload_preview;
    document.dispatchEvent(new CustomEvent('pp:uploadly-change'));
  }
  function readSelection() {
    const id = String(form?.elements.namedItem('id')?.value || '');
    const variant = cfg.variants.find(v => String(v.id) === id);
    const rule = variant && cfg.rules.find(r => r.size === variant.options[cfg.sizePosition - 1]);
    return rule ? { id, size: rule.size, ratios: rule.ratios, options: variant.options } : null;
  }
  function saveProperties(accepted) {
    if (!verified || !fileProof) return;
    const values = core.orderSnapshot(accepted, session.snapshot.selection, fileProof).properties;
    Object.entries(values).forEach(([name, value]) => {
      let input = form.querySelector(`[name="properties[${name}]"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${name}]`;
        input.dataset.ppCrop = 'true';
        form.append(input);
      }
      input.value = value;
    });
  }
  async function display(url, parentSignal) {
    previewCheck?.abort();
    previewCheck = new AbortController();
    const active = previewCheck;
    const stop = () => active.abort();
    parentSignal?.addEventListener('abort', stop, { once: true });
    if (parentSignal?.aborted) stop();
    const ticket = ++previewSequence;
    try {
      marker.dataset.previewState = 'loading';
      const size = await recovery.retry(signal => recovery.image(url, signal, core.PREVIEW_MAX), {
        signal: active.signal, delays: [0, 1000, 3000], timeout: 10000, budget: 30000,
        onRetry: (attempt, error) => record('preview-retry', `${attempt}: ${error.code}`)
      });
      await recovery.deadline(async signal => {
        while (typeof window.frameUp_setArtworkImageUrl !== 'function' || !main.querySelector('.starboard-container canvas')) await recovery.wait(250, signal);
      }, 20000, active.signal);
      if (ticket !== previewSequence || destroyed || paused || active.signal.aborted) throw recovery.error('cancelled');
      window.frameUp_setArtworkImageUrl(url);
      await recovery.wait(600, active.signal);
      if (ticket !== previewSequence || destroyed || paused || active.signal.aborted) throw recovery.error('cancelled');
      window.frameUp_setArtworkImageUrl(url);
      marker.dataset.previewUrl = url;
      marker.dataset.previewSize = `${size.width}x${size.height}`;
      marker.dataset.previewState = 'sent';
      record('preview-sent', marker.dataset.previewSize);
    } finally {
      parentSignal?.removeEventListener('abort', stop);
      if (previewCheck === active) previewCheck = null;
    }
  }
  function cancelWork() {
    fileCheck?.abort(); previewCheck?.abort();
    fileSequence++; previewSequence++; working = false;
  }
  function fail(reason, phase = 'crop') {
    verified = false;
    cancelWork();
    failurePhase = phase;
    session.fail();
    const codes = {
      'Crop does not match selected size': 'CROP-SHAPE', 'Invalid crop coordinates': 'CROP-COORDS',
      'Crop outside original image': 'CROP-BOUNDS', 'A full resolution crop is required': 'CROP-RESOLUTION',
      'Unsupported image operation': 'CROP-OPERATION', 'An image is required': 'CROP-IMAGE',
      'Original dimensions changed': 'FILE-DIMENSIONS', 'Print file does not match confirmed crop': 'FILE-CROP',
      'original-pending': 'FILE-PENDING', 'source-mismatch': 'FILE-SOURCE'
    };
    const code = codes[reason] || `${phase === 'crop' ? 'CROP' : phase === 'verification' ? 'FILE' : 'PREVIEW'}-${reason === 'timeout' ? 'TIMEOUT' : reason === 'network' ? 'NETWORK' : 'CHECK'}`;
    marker.dataset.errorCode = code;
    marker.dataset.failurePhase = phase;
    marker.dataset.failureReason = String(reason);
    if (phase === 'preview') marker.dataset.previewState = 'error';
    record('blocked', `${phase}: ${reason}`);
    render(`${cfg.words[phase === 'verification' ? 'verification_error' : phase === 'preview' ? 'preview_error' : 'crop_error']} ${cfg.words.help_code} ${code}`);
  }
  async function checkFiles(accepted, signal) {
    const infoUrl = new URL('https://upload.uploadcare.com/info/');
    infoUrl.search = new URLSearchParams({pub_key: cfg.publicKey, file_id: accepted.uuid}).toString();
    async function request(url, method = 'GET') {
      let response;
      try { response = await fetch(url, { method, signal, cache: 'no-store', credentials: 'omit' }); }
      catch (error) { throw recovery.error(signal.aborted ? 'cancelled' : 'network', !signal.aborted); }
      if (!response.ok) throw recovery.error(`http-${response.status}`, [404, 408, 425, 429].includes(response.status) || response.status >= 500);
      return response;
    }
    const [sourceResponse, renderResponse, printResponse] = await Promise.all([
      request(infoUrl), request(`${accepted.printReference}-/json/`), request(accepted.printReference, 'HEAD')
    ]);
    const [source, rendered] = await Promise.all([sourceResponse.json(), renderResponse.json()]);
    if (source.uuid !== accepted.uuid) throw recovery.error('source-mismatch');
    if (source.is_ready !== true || source.is_stored !== true) throw recovery.error('original-pending', true);
    if (!printResponse.headers.get('content-type')?.startsWith('image/jpeg') || Number(printResponse.headers.get('content-length')) < 1) throw recovery.error('print-response', true);
    return core.verifyFiles(accepted, source, rendered);
  }
  async function verifyAndDisplay(accepted, message) {
    cancelWork();
    fileCheck = new AbortController();
    const ticket = ++fileSequence;
    const abort = fileCheck;
    let phase = 'verification';
    working = true; verified = false; failurePhase = '';
    delete marker.dataset.errorCode; delete marker.dataset.failurePhase; delete marker.dataset.failureReason;
    const current = () => !destroyed && !paused && !abort.signal.aborted && ticket === fileSequence && session.snapshot.accepted === accepted && session.snapshot.status === 'ready';
    render(cfg.words.verifying);
    try {
      const proof = await recovery.retry(signal => checkFiles(accepted, signal), {
        signal: abort.signal,
        onRetry: (attempt, error) => {
          if (!current()) return;
          record('verification-retry', `${attempt}: ${error.code}`);
          render(cfg.words.retrying);
        }
      });
      if (!current()) return;
      fileProof = proof;
      marker.dataset.originalStored = 'true';
      marker.dataset.originalBytes = String(proof.sourceBytes);
      marker.dataset.printVerified = accepted.printReference;
      record('files-verified', `${accepted.width}x${accepted.height}; original stored`);
      phase = 'preview';
      render(cfg.words.loading_preview);
      await display(accepted.previewUrl, abort.signal);
      if (!current()) return;
      verified = true; working = false;
      saveProperties(accepted); render(message);
    } catch (error) {
      if (current() && error.code !== 'cancelled') fail(error.code || error.message, phase);
    } finally {
      if (ticket === fileSequence) working = false;
      if (fileCheck === abort) fileCheck = null;
    }
  }
  function retryPhoto() {
    if (working || paused || dialogActive || variantBusy) return;
    const accepted = session.snapshot.accepted;
    if (failurePhase !== 'crop' && accepted && session.recover(readSelection())) {
      record('retry-saved-photo');
      verifyAndDisplay(accepted);
    } else {
      reopen();
    }
  }
  function writeFormData(event) {
    if (event.target !== form) return;
    const state = session.snapshot;
    let allowed = !paused && !working && mounted && !variantBusy && !dialogActive && state.canSubmit && readSelection()?.id === state.selection?.id && (!state.accepted || verified);
    let snapshot = null;
    try { if (allowed && state.accepted) snapshot = core.orderSnapshot(state.accepted, state.selection, fileProof); }
    catch (_) { allowed = false; }
    core.writeOrderData(event.formData, cfg.fieldName, snapshot, allowed);
    marker.dataset.orderData = JSON.stringify({allowed, variant: event.formData.get('id'), properties: Object.fromEntries([...event.formData].filter(([name]) => name.startsWith('properties[')))});
  }
  function commit(token, file) {
    if (!file || typeof file.done !== 'function') return fail('not-single-file');
    function finish(info) {
      if (destroyed || session.snapshot.pending?.token !== token) return;
      if (paused) { resumeUpload = () => finish(info); return; }
      try {
        const accepted = session.accept(token, info);
        if (!accepted) { record('ignored-stale-crop'); return; }
        savedFile = file;
        saveProperties(accepted);
        record('crop-accepted', `${accepted.ratio} ${accepted.width}x${accepted.height}`);
        let attempts = 0;
        function check() {
          if (savedFile !== file || destroyed || dialogActive || session.snapshot.accepted !== accepted || session.snapshot.status !== 'ready') return;
          if (paused) { resumeUpload = check; return; }
          const inputs = nativeInputs().filter(input => input.value);
          if (!inputs.length) {
            if (++attempts < 100) return later(check, 100);
            return fail('missing-uploadly-order-property');
          }
          properties = [...new Map(inputs.map(input => [input.name, { name: input.name, value: input.value }])).values()];
          marker.dataset.nativeProperties = JSON.stringify(properties);
          verifyAndDisplay(accepted);
        }
        check();
      } catch (error) { fail(error.message); }
    }
    file.done(finish);
    function failed() {
      if (destroyed || session.snapshot.pending?.token !== token) return;
      if (paused) { resumeUpload = failed; return; }
      fail('upload-failed');
    }
    file.fail?.(failed);
  }
  function restore(token, previousFile, previousProperties) {
    if (session.snapshot.pending?.token !== token) return;
    if (paused) { resumeUpload = () => restore(token, previousFile, previousProperties); return; }
    const previous = session.cancel(token);
    suspended = true;
    try { widget.value(previousFile || null); } finally { suspended = false; }
    if (!previous) { verified = false; render(); return; }
    nativeInputs().forEach(input => input.remove());
    previousProperties.forEach(property => {
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = property.name; input.value = property.value;
      form.append(input);
    });
    const current = readSelection();
    if (current?.id !== previous.id) {
      const choices = [...main.querySelectorAll('input[data-option-position]')];
      const changed = choices.find(input => Number(input.dataset.optionPosition) === cfg.sizePosition && input.labels?.[0]?.textContent.trim() === previous.size);
      if (!changed) return fail('cannot-restore-size');
      changed.click();
      variantBusy = true;
    }
    saveProperties(session.snapshot.accepted);
    verifyAndDisplay(session.snapshot.accepted, cfg.words.cancelled);
    record('crop-cancelled', previous.size);
  }
  function installHook() {
    if (hook) return true;
    api = window.uploadcare;
    if (!api?.plugin || !api.fileFrom) return false;
    api.plugin(exports => {
      prototype = exports.widget?.BaseWidget?.prototype;
      cropPrototype = exports.crop?.CropWidget?.prototype;
    });
    originalMethod = prototype?.__openDialog;
    if (typeof originalMethod !== 'function') return false;
    originalSetCrop = cropPrototype?.setCrop;
    if (typeof originalSetCrop === 'function') {
      cropScaleHook = core.scaleCropHook(originalSetCrop, (instance, settings) => {
        if (destroyed || !dialogActive || !session.snapshot.pending || !instance.element?.[0]?.closest('.uploadcare--dialog')) return false;
        const size = settings?.preferedSize;
        return Array.isArray(size) && session.snapshot.pending.selection.ratios.some(value => Math.abs(core.ratio(value).value - size[0] / size[1]) < 1e-10);
      }, detail => {
        marker.dataset.cropScale = JSON.stringify(detail);
        record('crop-scale-corrected', `${detail.size.join(':')} ${detail.scale.join(',')}`);
      });
      cropPrototype.setCrop = cropScaleHook;
    }
    hook = function (tab) {
      const element = this.element?.[0];
      if (!field || !element || !(field === element || field.contains(element))) return originalMethod.call(this, tab);
      if (paused || variantBusy || !session.snapshot.selection || dialogActive) throw new Error('Crop selection is not ready');
      const previousFile = savedFile;
      const previousProperties = properties.map(p => ({ ...p }));
      const pending = session.begin();
      cancelWork();
      const originalSettings = this.settings;
      const originalObject = this.currentObject;
      const accepted = session.snapshot.accepted;
      this.settings = { ...originalSettings, crop: core.settings(pending.selection.ratios, accepted?.width < accepted?.height), systemDialog: false, previewStep: true };
      const sourceSettings = { ...this.settings, validators: core.metadataValidators(this.settings.validators || this.settings.__validators || []) };
      let originalSource = null;
      if (accepted) originalSource = api.fileFrom('uploaded', accepted.uuid, sourceSettings);
      originalSource?.fail?.(error => record('source-error', String(error)));
      originalSource?.done?.(info => record('source-ready', `${info.uuid} ${info.originalImageInfo?.width}x${info.originalImageInfo?.height}`));
      if (originalSource) this.currentObject = null;
      dialogActive = true; verified = false; render();
      record('dialog-open', this.settings.crop);
      let dialog;
      try {
        closeOrientation();
        closeCancel();
        closeHelp();
        closePolish();
        dialog = originalMethod.call(this, originalSource || this.currentObject ? 'preview' : tab);
        closeCancel = window.PPCropCancel.watch(dialog);
        closeHelp = window.PPUploadHelp?.watch(dialog) || (() => {});
        closePolish = window.PPUploadPolish?.watch(dialog) || (() => {});
        closeOrientation = window.PPCropOrientation.watch(dialog, {
          ratios: pending.selection.ratios,
          retainedUuid: accepted?.uuid,
          report(state, detail) {
            marker.dataset.autoOrientationState = state;
            if (state === 'waiting-metadata') {
              delete marker.dataset.autoOrientation;
              delete marker.dataset.autoOrientationRatio;
            }
            if (detail.orientation) {
              marker.dataset.autoOrientation = detail.orientation;
              marker.dataset.autoOrientationRatio = detail.ratio;
              marker.dataset.autoSourceSize = detail.sourceSize;
              record('auto-orientation', detail.ratio);
            }
          }
        });
        if (originalSource) {
          if (typeof dialog.addFiles !== 'function') throw new Error('Original-photo reopening is unavailable');
          dialog.addFiles([originalSource]);
        }
      }
      catch (error) { dialogActive = false; fail(error.message); throw error; }
      finally { this.settings = originalSettings; this.currentObject = originalObject; }
      dialog.done(file => {
        dialogActive = false;
        queueMicrotask(() => commit(pending.token, file));
      });
      dialog.fail(() => {
        dialogActive = false;
        queueMicrotask(() => restore(pending.token, previousFile, previousProperties));
      });
      return dialog;
    };
    prototype.__openDialog = hook;
    return true;
  }
  function connect() {
    if (widget || !field) return Boolean(widget);
    if (!installHook()) return false;
    const key = field.id.replace(/^selBtn_/, '');
    const entry = window.UPLOADCARE_DATA?.[key];
    if (!entry) return false;
    widget = entry.widget;
    if (!widget?.value || !widget?.onChange) { widget = null; return false; }
    widget.onChange(file => {
      if (destroyed || paused || suspended || dialogActive) return;
      if (!file) {
        session.clear(); savedFile = null; properties = []; verified = false;
        cancelWork(); fileProof = null; failurePhase = '';
        delete marker.dataset.errorCode; delete marker.dataset.failurePhase; delete marker.dataset.failureReason;
        delete marker.dataset.printVerified; delete marker.dataset.originalStored;
        form.querySelectorAll('[data-pp-crop]').forEach(input => input.remove());
        nativeInputs().forEach(input => input.remove());
        marker.dataset.nativeProperties = '[]';
        field.querySelectorAll('[data-prev-id]').forEach(preview => preview.remove());
        previewSequence++;
        if (cfg.example) display(cfg.example).catch(error => { if (error.code !== 'cancelled') record('example-preview-error', error.code || error.message); });
        record('removed'); render();
      }
    });
    marker.dataset.fieldKey = key;
    mounted = true; render();
    return true;
  }
  function reopen() {
    if (dialogActive || variantBusy) return;
    if (!connect()) return fail('widget-unavailable');
    try { widget.openDialog('preview'); } catch (error) { fail(error.message); }
  }
  function variantChanged() {
    variantBusy = false;
    const next = readSelection();
    const state = session.select(next);
    record('size-selected', next?.size || 'unknown');
    if (state === 'ready') saveProperties(session.snapshot.accepted);
    if (state === 'needs-crop') { cancelWork(); verified = false; later(reopen, 150); }
    render();
  }
  function beforeSubmit(event) {
    if (event.target !== form) return;
    const current = readSelection();
    if (paused || working || current?.id !== session.snapshot.selection?.id || !session.snapshot.canSubmit || variantBusy || !mounted || (session.snapshot.accepted && !verified)) {
      event.preventDefault(); event.stopImmediatePropagation();
      status.scrollIntoView({ block: 'center', behavior: 'smooth' });
      render(cfg.words.blocked);
    }
  }
  function fieldClick(event) {
    if (!connect()) return fail('hook-unavailable');
    if (!(event.target instanceof Element) || !event.target.closest('.pp-uploadly-photo-remove')) return;
    // Clear through the widget API so restored previews cannot reopen the editor.
    // The existing onChange handler clears the print data and Frame Up preview.
    event.preventDefault(); event.stopImmediatePropagation();
    if (!dialogActive && !variantBusy) widget.value(null);
  }
  function attach(attempt = 0) {
    field = document.querySelector(`[data-ph-fieldname="${cfg.fieldName}"]`);
    const picker = main?.querySelector('variant-picker[context="main_product"]');
    form = picker && document.getElementById(picker.getAttribute('form-id'));
    if (!form) form = main?.querySelector('form[is="product-form"]');
    if (!field || !form || !window.uploadcare) {
      if (attempt < 150) return later(() => attach(attempt + 1), 400);
      return fail('field-or-form-unavailable');
    }
    field.append(document.getElementById('pp-custom-crop-controls'));
    field.addEventListener('click', fieldClick, { capture: true, signal });
    field.addEventListener('dragenter', connect, { capture: true, signal });
    retry.addEventListener('click', retryPhoto, { signal });
    document.addEventListener('variant:change', event => {
      if (event.target === form || event.detail?.formId === form.getAttribute('id')) variantChanged();
    }, { signal });
    main.addEventListener('change', event => {
      if (event.target.matches('input[data-option-position]')) { variantBusy = true; render(cfg.words.waiting); }
    }, { capture: true, signal });
    document.addEventListener('submit', beforeSubmit, { capture: true, signal });
    form.addEventListener('formdata', writeFormData, {signal});
    session.select(readSelection());
    mounted = installHook();
    render();
    record('attached', form.getAttribute('id'));
    if (field.querySelector('.uploadcare--widget:not([data-ph-placeholder])')) connect();
  }
  window.addEventListener('pagehide', event => {
    if (event.persisted) {
      paused = true; cancelWork();
      if (session.snapshot.accepted) verified = false;
      record('page-paused');
      render();
      return;
    }
    destroyed = true; controller.abort(); timerIds.forEach(clearTimeout); cancelWork();
    closeOrientation();
    closeCancel();
    closeHelp();
    closePolish();
    if (prototype && hook && prototype.__openDialog === hook) prototype.__openDialog = originalMethod;
    if (cropPrototype && cropScaleHook && cropPrototype.setCrop === cropScaleHook) cropPrototype.setCrop = originalSetCrop;
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted || destroyed) return;
    paused = false;
    record('page-restored');
    if (resumeUpload) { const resume = resumeUpload; resumeUpload = null; resume(); return; }
    if (session.snapshot.accepted && !dialogActive && failurePhase !== 'crop') retryPhoto();
    else render();
  });
  attach();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-mobile-configurator"] && !Shopify.designMode) return;
  try {
    (()=>{
 const mobile=matchMedia('(max-width:699px)');
 const root=document.querySelector('.shopify-section--main-product .product');
 const words=document.getElementById('pp-mobile-config-text')?.dataset;
 if(!root||!words)return;
 let active=0,steps=[],gallery,price,buy,observer,raf=0,refreshFrame=0,enabled=false,purchaseSlot,priceHome,buyHome;
 const setText=(el,text)=>{if(el.textContent!==text)el.textContent=text};
 const topInset=()=>Math.max(0,...[...document.querySelectorAll('.shopify-section--announcement-bar,.shopify-section--header')].filter(e=>['sticky','fixed'].includes(getComputedStyle(e).position)).map(e=>Math.max(0,e.getBoundingClientRect().bottom)));
 function openStep(i){active=i;refresh();requestAnimationFrame(()=>{const target=steps[i]?.querySelector('.pp-mobile-step-toggle');if(!target)return;const offset=topInset()+gallery.offsetHeight+12;window.scrollBy({top:target.getBoundingClientRect().top-offset,behavior:'instant'});target.focus({preventScroll:true})})}
 function summary(step){
  const selected=step.querySelector('input[type="radio"]:checked');
  if(selected)return [...step.querySelectorAll('label')].find(e=>e.htmlFor===selected.id)?.textContent.trim()||'';
  return step.querySelector('.filepond--file-info-main')?.textContent.trim()||words.upload;
 }
 function refresh(){
  if(!enabled)return;
  const candidates=[...root.querySelectorAll('variant-picker>fieldset')];
  const upload=root.querySelector('[data-upload-lift]')?.closest('.product-info__block-item');
  if(upload){upload.classList.add('pp-mobile-upload');candidates.push(upload);for(const title of upload.querySelectorAll('.pp-upload-design-copy strong')){if(!title.dataset.ppOriginalText)title.dataset.ppOriginalText=title.textContent;setText(title,words.choosePhoto)}}
  steps=candidates;
  steps.forEach((step,i)=>{
   if(!step.classList.contains('pp-mobile-step')){
    const legend=step===upload?words.upload:step.querySelector('legend')?.textContent.trim().replace(/:$/,'')||words.upload;
    const body=document.createElement('div');body.className='pp-mobile-step-body';body.id='pp-mobile-body-'+i;
    while(step.firstChild)body.append(step.firstChild);
    const toggle=document.createElement('button');toggle.type='button';toggle.className='pp-mobile-step-toggle';toggle.setAttribute('aria-controls',body.id);
    const title=document.createElement('strong');title.textContent=(i+1)+'. '+legend;
    const value=document.createElement('span');const icon=document.createElement('b');icon.setAttribute('aria-hidden','true');
    toggle.append(title,value,icon);toggle.addEventListener('click',()=>{if(active===i){active=-1;refresh()}else openStep(i)});
    const next=document.createElement('button');next.type='button';next.className='pp-mobile-next';next.textContent=words.continue;
    next.addEventListener('click',()=>openStep(i+1));
    if(i<steps.length-1)body.append(next);
    step.append(toggle,body);step.classList.add('pp-mobile-step');
   }
   const open=i===active;step.dataset.open=String(open);
   const toggle=step.querySelector(':scope>.pp-mobile-step-toggle');toggle.setAttribute('aria-expanded',String(open));
   setText(toggle.querySelector('span'),summary(step));setText(toggle.querySelector('b'),open?'−':'+');
   const help=step.querySelector('.pp-edge-help-trigger');
   const orientation=step.querySelector('.pp-orientation-note__trigger');
   if(orientation&&!step.querySelector(':scope>.pp-mobile-orientation-help')){
    const original=document.getElementById(orientation.getAttribute('popovertarget'));
    if(original){
     const popup=original.cloneNode(true);popup.id=original.id+'-mobile';popup.classList.add('pp-mobile-orientation-popup');
     const title=popup.querySelector('.pp-orientation-note__title');title.id=popup.id+'-title';popup.setAttribute('aria-labelledby',title.id);
     popup.querySelector('[popovertargetaction="hide"]').setAttribute('popovertarget',popup.id);
     const control=document.createElement('button');control.type='button';control.className='pp-mobile-edge-help pp-mobile-orientation-help';control.setAttribute('popovertarget',popup.id);control.setAttribute('aria-haspopup','dialog');
     const icon=orientation.querySelector('.pp-orientation-note__icon')?.cloneNode(true);if(icon)control.append(icon);
     const label=document.createElement('span');label.textContent=[...orientation.childNodes].filter(n=>n.nodeType===3).map(n=>n.textContent).join('').trim();control.append(label);
     toggle.after(control,popup);
    }
   }
   if(help&&!step.querySelector(':scope>.pp-mobile-edge-help')){
    const control=document.createElement('button');control.type='button';control.className='pp-mobile-edge-help';
    const icon=help.querySelector('svg')?.cloneNode(true);if(icon){icon.removeAttribute('id');icon.setAttribute('aria-hidden','true');control.append(icon)}
    const label=document.createElement('span');label.textContent=words.edgeHelp;control.append(label);
    control.addEventListener('click',()=>step.querySelector('.pp-edge-help-trigger')?.click());step.append(control);
   }
  });
  const badge=root.querySelector('.jdgm-preview-badge')?.closest('.product-info__block-item');badge?.classList.add('pp-mobile-rating');
  updateSticky();
 }
 function updateSticky(){
  if(!enabled||raf)return;
  raf=requestAnimationFrame(()=>{raf=0;
   const base=topInset();
   const end=purchaseSlot.getBoundingClientRect().bottom;
   const top=Math.min(base,end-gallery.offsetHeight-12);
   const val=Math.round(top)+'px';if(gallery.style.getPropertyValue('--pp-mobile-top')!==val)gallery.style.setProperty('--pp-mobile-top',val);
  });
 }
 function queueRefresh(){
  if(!enabled||refreshFrame)return;
  refreshFrame=requestAnimationFrame(()=>{refreshFrame=0;observer?.disconnect();refresh();observer?.observe(root,{childList:true,subtree:true})});
 }
 function start(){
  if(enabled||!mobile.matches)return;
  gallery=root.querySelector('product-gallery');price=root.querySelector('[data-block-type="price"]');buy=root.querySelector('[data-block-type="buy-buttons"]');
  if(!gallery?.querySelector('.starboard-super-container')||!price||!buy)return false;
  enabled=true;
  priceHome=document.createComment('mobile price position');buyHome=document.createComment('mobile buy position');
  price.before(priceHome);buy.before(buyHome);
  purchaseSlot=document.createElement('div');purchaseSlot.className='pp-mobile-purchase-slot';
  const purchase=document.createElement('div');purchase.className='pp-mobile-purchase';
  buy.after(purchaseSlot);purchaseSlot.append(purchase);purchase.append(price,buy);
  root.classList.add('pp-mobile-config');refresh();
  observer=new MutationObserver(records=>{
   if(records.some(record=>record.target instanceof Element&&(record.target.closest('variant-picker,.pp-mobile-upload,[data-block-type="price"]')||[...record.addedNodes].some(node=>node instanceof Element&&(node.matches('variant-picker,[data-upload-lift]')||node.querySelector('variant-picker,[data-upload-lift]'))))))queueRefresh();
  });observer.observe(root,{childList:true,subtree:true});
  root.addEventListener('change',queueRefresh);
  window.addEventListener('scroll',updateSticky,{passive:true});window.addEventListener('resize',updateSticky);
  return true;
 }
 function stop(){
  observer?.disconnect();enabled=false;cancelAnimationFrame(raf);cancelAnimationFrame(refreshFrame);raf=0;refreshFrame=0;root.removeEventListener('change',queueRefresh);root.classList.remove('pp-mobile-config');gallery?.style.removeProperty('--pp-mobile-top');
  const currentPrice=purchaseSlot?.querySelector('[data-block-type="price"]');
  const currentBuy=purchaseSlot?.querySelector('[data-block-type="buy-buttons"]');
  if(priceHome?.isConnected&&currentPrice)priceHome.replaceWith(currentPrice);if(buyHome?.isConnected&&currentBuy)buyHome.replaceWith(currentBuy);purchaseSlot?.remove();
  for(const popup of root.querySelectorAll('.pp-mobile-orientation-popup'))popup.remove();
  for(const title of root.querySelectorAll('[data-pp-original-text]')){title.textContent=title.dataset.ppOriginalText;delete title.dataset.ppOriginalText}
  for(const step of root.querySelectorAll('.pp-mobile-step')){const body=step.querySelector(':scope>.pp-mobile-step-body');body?.querySelector(':scope>.pp-mobile-next')?.remove();step.querySelector(':scope>.pp-mobile-edge-help')?.remove();step.querySelector(':scope>.pp-mobile-step-toggle')?.remove();if(body){body.replaceWith(...body.childNodes)}step.classList.remove('pp-mobile-step');delete step.dataset.open}
  window.removeEventListener('scroll',updateSticky);window.removeEventListener('resize',updateSticky);
 }
 let timer;
 function boot(){
  clearInterval(timer);
  if(!mobile.matches||start())return;
  let tries=0;
  timer=setInterval(()=>{if(start()||++tries>=60)clearInterval(timer)},500);
 }
 mobile.addEventListener('change',()=>{if(mobile.matches)boot();else{clearInterval(timer);stop()}});
 window.addEventListener('pagehide',()=>{clearInterval(timer);stop()});
 window.addEventListener('pageshow',event=>{if(event.persisted)boot()});
 boot();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-mobile-customer"] && !Shopify.designMode) return;
  try {
    (()=>{
 const mobile=matchMedia('(max-width:699px)');
 const root=document.querySelector('.shopify-section--main-product .product');
 const words=document.getElementById('pp-mobile-customer-text')?.dataset;
 if(!root||!words)return;
 let active=0,steps=[],gallery,price,buy,observer,raf=0,refreshFrame=0,enabled=false,purchaseSlot,priceHome,buyHome;
 const setText=(el,text)=>{if(el.textContent!==text)el.textContent=text};
 const topInset=()=>Math.max(0,...[...document.querySelectorAll('.shopify-section--announcement-bar,.shopify-section--header')].filter(e=>['sticky','fixed'].includes(getComputedStyle(e).position)).map(e=>Math.max(0,e.getBoundingClientRect().bottom)));
 function openStep(i){active=i;refresh();requestAnimationFrame(()=>{const target=steps[i]?.querySelector('.pp-mobile-step-toggle');if(!target)return;const offset=topInset()+gallery.offsetHeight+12;window.scrollBy({top:target.getBoundingClientRect().top-offset,behavior:'instant'});target.focus({preventScroll:true})})}
 function summary(step){
  const selected=step.querySelector('input[type="radio"]:checked');
  if(selected)return [...step.querySelectorAll('label')].find(e=>e.htmlFor===selected.id)?.textContent.trim()||'';
  return root.querySelector('[data-pp-customer]')?.dataset.summary||words.upload;
 }
 function refresh(){
  if(!enabled)return;
  const candidates=[...root.querySelectorAll('variant-picker>fieldset')];
  const upload=root.querySelector('[data-pp-customer]')?.closest('.product-info__block-item');
  if(upload){upload.classList.add('pp-mobile-upload');candidates.push(upload)}
  steps=candidates;
  steps.forEach((step,i)=>{
   if(!step.classList.contains('pp-mobile-step')){
    const legend=step===upload?words.upload:step.querySelector('legend')?.textContent.trim().replace(/:$/,'')||words.upload;
    const body=document.createElement('div');body.className='pp-mobile-step-body';body.id='pp-mobile-body-'+i;
    while(step.firstChild)body.append(step.firstChild);
    const toggle=document.createElement('button');toggle.type='button';toggle.className='pp-mobile-step-toggle';toggle.setAttribute('aria-controls',body.id);
    const title=document.createElement('strong');title.textContent=(i+1)+'. '+legend;
    const value=document.createElement('span');const icon=document.createElement('b');icon.setAttribute('aria-hidden','true');
    toggle.append(title,value,icon);toggle.addEventListener('click',()=>{if(active===i){active=-1;refresh()}else openStep(i)});
    step.append(toggle,body);step.classList.add('pp-mobile-step');
   }
   const body=step.querySelector(':scope>.pp-mobile-step-body');
   let next=body.querySelector(':scope>.pp-mobile-next');
   if(i<steps.length-1&&!next){
    next=document.createElement('button');next.type='button';next.className='pp-mobile-next';next.textContent=words.continue;
    next.addEventListener('click',()=>openStep(steps.indexOf(step)+1));body.append(next);
   }else if(i===steps.length-1&&next)next.remove();
   const open=i===active;step.dataset.open=String(open);
   const toggle=step.querySelector(':scope>.pp-mobile-step-toggle');toggle.setAttribute('aria-expanded',String(open));
   setText(toggle.querySelector('span'),summary(step));setText(toggle.querySelector('b'),open?'−':'+');
   const help=step.querySelector('.pp-edge-help-trigger');
   const orientation=step.querySelector('.pp-orientation-note__trigger');
   if(orientation&&!step.querySelector(':scope>.pp-mobile-orientation-help')){
    const original=document.getElementById(orientation.getAttribute('popovertarget'));
    if(original){
     const popup=original.cloneNode(true);popup.id=original.id+'-mobile';popup.classList.add('pp-mobile-orientation-popup');
     const title=popup.querySelector('.pp-orientation-note__title');title.id=popup.id+'-title';popup.setAttribute('aria-labelledby',title.id);
     popup.querySelector('[popovertargetaction="hide"]').setAttribute('popovertarget',popup.id);
     const control=document.createElement('button');control.type='button';control.className='pp-mobile-edge-help pp-mobile-orientation-help';control.setAttribute('popovertarget',popup.id);control.setAttribute('aria-haspopup','dialog');
     const icon=orientation.querySelector('.pp-orientation-note__icon')?.cloneNode(true);if(icon)control.append(icon);
     const label=document.createElement('span');label.textContent=[...orientation.childNodes].filter(n=>n.nodeType===3).map(n=>n.textContent).join('').trim();control.append(label);
     toggle.after(control,popup);
    }
   }
   if(help&&!step.querySelector(':scope>.pp-mobile-edge-help')){
    const control=document.createElement('button');control.type='button';control.className='pp-mobile-edge-help';
    const icon=help.querySelector('svg')?.cloneNode(true);if(icon){icon.removeAttribute('id');icon.setAttribute('aria-hidden','true');control.append(icon)}
    const label=document.createElement('span');label.textContent=words.edgeHelp;control.append(label);
    control.addEventListener('click',()=>step.querySelector('.pp-edge-help-trigger')?.click());step.append(control);
   }
  });
  const badge=root.querySelector('.jdgm-preview-badge')?.closest('.product-info__block-item');badge?.classList.add('pp-mobile-rating');
  updateSticky();
 }
 function updateSticky(){
  if(!enabled||raf)return;
  raf=requestAnimationFrame(()=>{raf=0;
   const base=topInset();
   const end=purchaseSlot.getBoundingClientRect().bottom;
   const top=Math.min(base,end-gallery.offsetHeight-12);
   const val=Math.round(top)+'px';if(gallery.style.getPropertyValue('--pp-mobile-top')!==val)gallery.style.setProperty('--pp-mobile-top',val);
  });
 }
 function queueRefresh(){
  if(!enabled||refreshFrame)return;
  refreshFrame=requestAnimationFrame(()=>{refreshFrame=0;observer?.disconnect();refresh();observer?.observe(root,{childList:true,subtree:true})});
 }
 function start(){
  if(enabled||!mobile.matches)return;
  gallery=root.querySelector('product-gallery');price=root.querySelector('[data-block-type="price"]');buy=root.querySelector('[data-block-type="buy-buttons"]');
  if(!gallery||!price||!buy)return false;
  if(!root.hasAttribute('data-pp-layout-trial')&&!gallery.querySelector('.starboard-super-container'))return false;
  enabled=true;
  priceHome=document.createComment('mobile price position');buyHome=document.createComment('mobile buy position');
  price.before(priceHome);buy.before(buyHome);
  purchaseSlot=document.createElement('div');purchaseSlot.className='pp-mobile-purchase-slot';
  const purchase=document.createElement('div');purchase.className='pp-mobile-purchase';
  buy.after(purchaseSlot);purchaseSlot.append(purchase);purchase.append(price,buy);
  root.classList.add('pp-mobile-config');refresh();
  observer=new MutationObserver(records=>{
   if(records.some(record=>record.target instanceof Element&&(record.target.closest('variant-picker,.pp-mobile-upload,[data-block-type="price"]')||[...record.addedNodes].some(node=>node instanceof Element&&(node.matches('variant-picker,[data-pp-customer]')||node.querySelector('variant-picker,[data-pp-customer]'))))))queueRefresh();
  });observer.observe(root,{childList:true,subtree:true});
  root.addEventListener('change',queueRefresh);
  document.addEventListener('pp:customer-change',queueRefresh);
  window.addEventListener('scroll',updateSticky,{passive:true});window.addEventListener('resize',updateSticky);
  return true;
 }
 function stop(){
  observer?.disconnect();enabled=false;cancelAnimationFrame(raf);cancelAnimationFrame(refreshFrame);raf=0;refreshFrame=0;root.removeEventListener('change',queueRefresh);document.removeEventListener('pp:customer-change',queueRefresh);root.classList.remove('pp-mobile-config');gallery?.style.removeProperty('--pp-mobile-top');
  const currentPrice=purchaseSlot?.querySelector('[data-block-type="price"]');
  const currentBuy=purchaseSlot?.querySelector('[data-block-type="buy-buttons"]');
  if(priceHome?.isConnected&&currentPrice)priceHome.replaceWith(currentPrice);if(buyHome?.isConnected&&currentBuy)buyHome.replaceWith(currentBuy);purchaseSlot?.remove();
  for(const popup of root.querySelectorAll('.pp-mobile-orientation-popup'))popup.remove();
  for(const title of root.querySelectorAll('[data-pp-original-text]')){title.textContent=title.dataset.ppOriginalText;delete title.dataset.ppOriginalText}
  for(const step of root.querySelectorAll('.pp-mobile-step')){const body=step.querySelector(':scope>.pp-mobile-step-body');body?.querySelector(':scope>.pp-mobile-next')?.remove();step.querySelector(':scope>.pp-mobile-edge-help')?.remove();step.querySelector(':scope>.pp-mobile-step-toggle')?.remove();if(body){body.replaceWith(...body.childNodes)}step.classList.remove('pp-mobile-step');delete step.dataset.open}
  window.removeEventListener('scroll',updateSticky);window.removeEventListener('resize',updateSticky);
 }
 let timer;
 function boot(){
  clearInterval(timer);
  if(!mobile.matches||start())return;
  let tries=0;
  timer=setInterval(()=>{if(start()||++tries>=60)clearInterval(timer)},500);
 }
 mobile.addEventListener('change',()=>{if(mobile.matches)boot();else{clearInterval(timer);stop()}});
 window.addEventListener('pagehide',()=>{clearInterval(timer);stop()});
 window.addEventListener('pageshow',event=>{if(event.persisted)boot()});
 boot();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-mobile-uploadly-custom"] && !Shopify.designMode) return;
  try {
    (()=>{
 const mobile=matchMedia('(max-width:699px)');
 const root=document.querySelector('.shopify-section--main-product .product');
 const words=document.getElementById('pp-mobile-uploadly-custom-text')?.dataset;
 if(!root||!words)return;
 let active=0,steps=[],gallery,price,buy,observer,raf=0,refreshFrame=0,enabled=false,purchaseSlot,priceHome,buyHome;
 const setText=(el,text)=>{if(el.textContent!==text)el.textContent=text};
 const topInset=()=>Math.max(0,...[...document.querySelectorAll('.shopify-section--announcement-bar,.shopify-section--header')].filter(e=>['sticky','fixed'].includes(getComputedStyle(e).position)).map(e=>Math.max(0,e.getBoundingClientRect().bottom)));
 function openStep(i){active=i;refresh();requestAnimationFrame(()=>{const target=steps[i]?.querySelector('.pp-mobile-step-toggle');if(!target)return;const offset=topInset()+gallery.offsetHeight+12;window.scrollBy({top:target.getBoundingClientRect().top-offset,behavior:'instant'});target.focus({preventScroll:true})})}
 function summary(step){
  const selected=step.querySelector('input[type="radio"]:checked');
  if(selected)return [...step.querySelectorAll('label')].find(e=>e.htmlFor===selected.id)?.textContent.trim()||'';
  return document.getElementById('pp-uploadly-custom-pilot')?.dataset.filename||words.upload;
 }
 function refresh(){
  if(!enabled)return;
  const candidates=[...root.querySelectorAll('variant-picker>fieldset')];
  const upload=root.querySelector('[data-ph-fieldname]')?.closest('.product-info__block-item');
  if(upload){upload.classList.add('pp-mobile-upload');candidates.push(upload)}
  steps=candidates;
  steps.forEach((step,i)=>{
   if(!step.classList.contains('pp-mobile-step')){
    const legend=step===upload?words.upload:step.querySelector('legend')?.textContent.trim().replace(/:$/,'')||words.upload;
    const body=document.createElement('div');body.className='pp-mobile-step-body';body.id='pp-mobile-body-'+i;
    while(step.firstChild)body.append(step.firstChild);
    const toggle=document.createElement('button');toggle.type='button';toggle.className='pp-mobile-step-toggle';toggle.setAttribute('aria-controls',body.id);
    const title=document.createElement('strong');title.textContent=(i+1)+'. '+legend;
    const value=document.createElement('span');const icon=document.createElement('b');icon.setAttribute('aria-hidden','true');
    toggle.append(title,value,icon);toggle.addEventListener('click',()=>{if(active===i){active=-1;refresh()}else openStep(i)});
    step.append(toggle,body);step.classList.add('pp-mobile-step');
   }
   const body=step.querySelector(':scope>.pp-mobile-step-body');
   let next=body.querySelector(':scope>.pp-mobile-next');
   if(i<steps.length-1&&!next){
    next=document.createElement('button');next.type='button';next.className='pp-mobile-next';next.textContent=words.continue;
    next.addEventListener('click',()=>openStep(steps.indexOf(step)+1));body.append(next);
   }else if(i===steps.length-1&&next)next.remove();
   const open=i===active;step.dataset.open=String(open);
   const toggle=step.querySelector(':scope>.pp-mobile-step-toggle');toggle.setAttribute('aria-expanded',String(open));
   setText(toggle.querySelector('span'),summary(step));setText(toggle.querySelector('b'),open?'−':'+');
   const help=step.querySelector('.pp-edge-help-trigger');
   const orientation=step.querySelector('.pp-orientation-note__trigger');
   if(orientation&&!step.querySelector(':scope>.pp-mobile-orientation-help')){
    const original=document.getElementById(orientation.getAttribute('popovertarget'));
    if(original){
     const popup=original.cloneNode(true);popup.id=original.id+'-mobile';popup.classList.add('pp-mobile-orientation-popup');
     const title=popup.querySelector('.pp-orientation-note__title');title.id=popup.id+'-title';popup.setAttribute('aria-labelledby',title.id);
     popup.querySelector('[popovertargetaction="hide"]').setAttribute('popovertarget',popup.id);
     const control=document.createElement('button');control.type='button';control.className='pp-mobile-edge-help pp-mobile-orientation-help';control.setAttribute('popovertarget',popup.id);control.setAttribute('aria-haspopup','dialog');
     const icon=orientation.querySelector('.pp-orientation-note__icon')?.cloneNode(true);if(icon)control.append(icon);
     const label=document.createElement('span');label.textContent=[...orientation.childNodes].filter(n=>n.nodeType===3).map(n=>n.textContent).join('').trim();control.append(label);
     toggle.after(control,popup);
    }
   }
   if(help&&!step.querySelector(':scope>.pp-mobile-edge-help')){
    const control=document.createElement('button');control.type='button';control.className='pp-mobile-edge-help';
    const icon=help.querySelector('svg')?.cloneNode(true);if(icon){icon.removeAttribute('id');icon.setAttribute('aria-hidden','true');control.append(icon)}
    const label=document.createElement('span');label.textContent=words.edgeHelp;control.append(label);
    control.addEventListener('click',()=>step.querySelector('.pp-edge-help-trigger')?.click());step.append(control);
   }
  });
  const badge=root.querySelector('.jdgm-preview-badge')?.closest('.product-info__block-item');badge?.classList.add('pp-mobile-rating');
  updateSticky();
 }
 function updateSticky(){
  if(!enabled||raf)return;
  raf=requestAnimationFrame(()=>{raf=0;
   const base=topInset();
   const end=purchaseSlot.getBoundingClientRect().bottom;
   const top=Math.min(base,end-gallery.offsetHeight-12);
   const val=Math.round(top)+'px';if(gallery.style.getPropertyValue('--pp-mobile-top')!==val)gallery.style.setProperty('--pp-mobile-top',val);
  });
 }
 function queueRefresh(){
  if(!enabled||refreshFrame)return;
  refreshFrame=requestAnimationFrame(()=>{refreshFrame=0;observer?.disconnect();refresh();observer?.observe(root,{childList:true,subtree:true})});
 }
 function start(){
  if(enabled||!mobile.matches)return;
  gallery=root.querySelector('product-gallery');price=root.querySelector('[data-block-type="price"]');buy=root.querySelector('[data-block-type="buy-buttons"]');
  if(!gallery||!price||!buy)return false;
  if(!root.hasAttribute('data-pp-layout-trial')&&!gallery.querySelector('.starboard-super-container'))return false;
  enabled=true;
  priceHome=document.createComment('mobile price position');buyHome=document.createComment('mobile buy position');
  price.before(priceHome);buy.before(buyHome);
  purchaseSlot=document.createElement('div');purchaseSlot.className='pp-mobile-purchase-slot';
  const purchase=document.createElement('div');purchase.className='pp-mobile-purchase';
  buy.after(purchaseSlot);purchaseSlot.append(purchase);purchase.append(price,buy);
  root.classList.add('pp-mobile-config');refresh();
  observer=new MutationObserver(records=>{
   if(records.some(record=>record.target instanceof Element&&(record.target.closest('variant-picker,.pp-mobile-upload,[data-block-type="price"]')||[...record.addedNodes].some(node=>node instanceof Element&&(node.matches('variant-picker,[data-ph-fieldname]')||node.querySelector('variant-picker,[data-ph-fieldname]'))))))queueRefresh();
  });observer.observe(root,{childList:true,subtree:true});
  root.addEventListener('change',queueRefresh);
  document.addEventListener('pp:uploadly-change',queueRefresh);
  window.addEventListener('scroll',updateSticky,{passive:true});window.addEventListener('resize',updateSticky);
  return true;
 }
 function stop(){
  observer?.disconnect();enabled=false;cancelAnimationFrame(raf);cancelAnimationFrame(refreshFrame);raf=0;refreshFrame=0;root.removeEventListener('change',queueRefresh);document.removeEventListener('pp:uploadly-change',queueRefresh);root.classList.remove('pp-mobile-config');gallery?.style.removeProperty('--pp-mobile-top');
  const currentPrice=purchaseSlot?.querySelector('[data-block-type="price"]');
  const currentBuy=purchaseSlot?.querySelector('[data-block-type="buy-buttons"]');
  if(priceHome?.isConnected&&currentPrice)priceHome.replaceWith(currentPrice);if(buyHome?.isConnected&&currentBuy)buyHome.replaceWith(currentBuy);purchaseSlot?.remove();
  for(const popup of root.querySelectorAll('.pp-mobile-orientation-popup'))popup.remove();
  for(const title of root.querySelectorAll('[data-pp-original-text]')){title.textContent=title.dataset.ppOriginalText;delete title.dataset.ppOriginalText}
  for(const step of root.querySelectorAll('.pp-mobile-step')){const body=step.querySelector(':scope>.pp-mobile-step-body');body?.querySelector(':scope>.pp-mobile-next')?.remove();step.querySelector(':scope>.pp-mobile-edge-help')?.remove();step.querySelector(':scope>.pp-mobile-step-toggle')?.remove();if(body){body.replaceWith(...body.childNodes)}step.classList.remove('pp-mobile-step');delete step.dataset.open}
  window.removeEventListener('scroll',updateSticky);window.removeEventListener('resize',updateSticky);
 }
 let timer;
 function boot(){
  clearInterval(timer);
  if(!mobile.matches||start())return;
  let tries=0;
  timer=setInterval(()=>{if(start()||++tries>=60)clearInterval(timer)},500);
 }
 mobile.addEventListener('change',()=>{if(mobile.matches)boot();else{clearInterval(timer);stop()}});
 window.addEventListener('pagehide',()=>{clearInterval(timer);stop()});
 window.addEventListener('pageshow',event=>{if(event.persisted)boot()});
 boot();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-product-card-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-card-size-range')) {
    customElements.define('pp-card-size-range', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const choices = this.querySelector('.pp-b2__shape-switch');
        if (!choices) return;
        const buttons = [...choices.querySelectorAll('[data-pp-shape]')];
        const ranges = [...this.querySelectorAll('[data-pp-range]')];
        const select = shape => {
          ranges.forEach(range => { range.hidden = range.dataset.ppRange !== shape; });
          buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ppShape === shape)));
        };
        select(buttons[0].dataset.ppShape);
        choices.hidden = false;
        this.dataset.ready = 'true';
        choices.addEventListener('click', event => {
          const button = event.target.closest('[data-pp-shape]');
          if (button && choices.contains(button)) select(button.dataset.ppShape);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-uploadly-custom-steps"] && !Shopify.designMode) return;
  try {
    (() => {
  const source = document.getElementById('pp-uploadly-custom-heading-template');
  const main = document.querySelector('.shopify-section--main-product');
  const marker = document.getElementById('pp-uploadly-custom-pilot');
  if (!source || !main || !marker) return;
  document.body.classList.add('pp-uploadly-branded');
  let observer, pending = 0;
  const observerOptions = {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['style']};
  function refresh() {
    const groups = [...main.querySelectorAll('variant-picker > fieldset')];
    const field = main.querySelector('[data-ph-fieldname="Your photo"]');
    if (field && !field.querySelector('.pp-uploadly-step-heading')) field.prepend(source.content.cloneNode(true));
    const button = field?.querySelector('.uploadcare--widget__button_type_open');
    const buttonTemplate = document.getElementById('pp-uploadly-custom-button-template');
    if (button && buttonTemplate && !button.querySelector('.pp-uploadly-button-title')) {
      button.replaceChildren(buttonTemplate.content.cloneNode(true));
      button.setAttribute('aria-label', 'Upload your photo');
    }
    const changeButton = field?.querySelector('.uploadcare--widget__file-name');
    if (changeButton && source.dataset.changeLabel) {
      if (changeButton.textContent !== source.dataset.changeLabel) changeButton.textContent = source.dataset.changeLabel;
      if (changeButton.getAttribute('aria-label') !== source.dataset.changeLabel) changeButton.setAttribute('aria-label', source.dataset.changeLabel);
    }
    window.PPUploadPolish?.card(field, marker);
    // The app applies inline !important presentation rules after mounting.
    // Remove only those overrides, never native visibility/state properties.
    if (button) ['width','height','padding','border-radius','color','font-size','font-weight','font-family','line-height','white-space'].forEach(property => button.style.removeProperty(property));
    [...(field?.children || [])].filter(node => node.tagName === 'P' && node.textContent.trim() === 'Upload a file:').forEach(node => node.classList.add('pp-uploadly-native-label'));
    const headings = groups.map(group => group.querySelector('.variant-picker__option-info .h-stack'));
    headings.push(field?.querySelector('.pp-uploadly-step-heading'));
    headings.forEach((heading, index) => {
      if (!heading) return;
      heading.classList.add('pp-step-heading');
      let badge = heading.querySelector(':scope > .pp-step-badge');
      if (!badge) { badge = document.createElement('span'); badge.className = 'pp-step-badge'; heading.prepend(badge); }
      const text = source.dataset.step + ' ' + (index + 1);
      if (badge.textContent !== text) badge.textContent = text;
    });
    const container = main.querySelector('.starboard-super-container');
    let intro = container?.querySelector('[data-pp-preview-intro]');
    if (container && !intro) {
      const template = document.querySelector('[data-pp-preview-intro-template]');
      if (template) { container.append(template.content.cloneNode(true)); intro = container.querySelector('[data-pp-preview-intro]'); }
    }
    if (intro) intro.hidden = Boolean(marker.dataset.cropSource);
  }
  function schedule() {
    if (pending) return;
    pending = requestAnimationFrame(() => { pending = 0; observer.disconnect(); refresh(); observer.observe(main, observerOptions); });
  }
  observer = new MutationObserver(records => {
    if (records.some(record => {
      const target = record.target.nodeType === Node.TEXT_NODE ? record.target.parentElement : record.target;
      return target instanceof Element && (target.matches('.uploadcare--widget__file-name') || (record.type === 'childList' && target.closest('[data-prev-id]')));
    })) return schedule();
    if (records.some(record => (record.type === 'attributes' && record.target.matches('.uploadcare--widget__button_type_open')) || [...record.addedNodes].some(node => node instanceof Element && (node.matches('variant-picker,[data-ph-fieldname],.starboard-super-container,.uploadcare--widget__button_type_open,.uploadcare--widget__file-name,[data-prev-id]') || node.querySelector('variant-picker,[data-ph-fieldname],.starboard-super-container,.uploadcare--widget__button_type_open,.uploadcare--widget__file-name,[data-prev-id]'))))) schedule();
  });
  refresh(); observer.observe(main, observerOptions);
  document.addEventListener('pp:uploadly-change', schedule);
  window.addEventListener('pagehide', event => { if (event.persisted) return; observer.disconnect(); cancelAnimationFrame(pending); document.removeEventListener('pp:uploadly-change', schedule); });
  window.addEventListener('pageshow', event => { if (event.persisted) schedule(); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-uploadly-help"] && !Shopify.designMode) return;
  try {
    (function(root,factory){
  if(typeof module==='object'&&module.exports) module.exports=factory;
  else root.PPUploadHelp=factory(root);
})(typeof window!=='undefined'?window:this,function(env){
  'use strict';
  const doc=env.document;
  function chat(event,dialog){
    if(typeof env.Reamaze?.popup!=='function') return;
    try{
      dialog?.reject();
      env.Reamaze.popup();
      event.preventDefault();
    }catch(_){}
  }
  const line=doc.getElementById('pp-upload-help-line');
  const lineClick=event=>{if(event.target.closest?.('[data-pp-upload-chat]')) chat(event);};
  line?.addEventListener('click',lineClick);
  env.addEventListener?.('pagehide',()=>line?.removeEventListener('click',lineClick),{once:true});
  function watch(dialog){
    const template=doc.getElementById('pp-upload-help-template');
    const collection=dialog?.fileColl;
    if(!template||typeof dialog?.reject!=='function'||typeof dialog?.always!=='function'||!collection?.onAdd?.add||!collection?.onRemove?.add||typeof collection.get!=='function') return ()=>{};
    let root,observer,bootstrap,stallTimer,frame,closed=false,current=null,failed=false,slow=false,panel=null,host=null,mode='';
    const watched=new WeakSet();
    const visible=element=>Boolean(element&&element.getClientRects().length);
    function removePanel(){
      host?.classList.remove('pp-upload-help-replaced');
      panel?.remove();panel=null;host=null;mode='';
    }
    function inspect(){
      frame=0;
      if(closed||!root) return;
      observer.disconnect();
      const error=[...root.querySelectorAll('.uploadcare--preview__content.uploadcare--error')].find(visible);
      const preview=[...root.querySelectorAll('.uploadcare--preview__content')].find(visible);
      const image=preview?.querySelector('.uploadcare--preview__image');
      const ready=visible(image)&&image.complete&&image.naturalWidth>0&&image.naturalHeight>0;
      const nextMode=error?'error':preview&&current&&!ready?(failed?'error':slow?'slow':''):'';
      const nextHost=error||preview;
      if(!nextMode){removePanel();if(ready) env.clearTimeout(stallTimer);}
      else if(nextHost!==host||nextMode!==mode||!panel?.isConnected){
        removePanel();host=nextHost;mode=nextMode;
        panel=template.content.firstElementChild.cloneNode(true);
        if(mode==='slow'){
          panel.querySelector('.pp-upload-help-title').textContent=template.dataset.slowTitle;
          panel.querySelector('.pp-upload-help-message').textContent=template.dataset.slowMessage;
        }
        if(error) host.classList.add('pp-upload-help-replaced');
        host.append(panel);
      }
      observer.observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['class','src','hidden']});
    }
    function schedule(){if(!closed&&!frame) frame=env.requestAnimationFrame(inspect);}
    function resetClock(){
      slow=false;env.clearTimeout(stallTimer);
      stallTimer=env.setTimeout(()=>{slow=true;schedule();},45000);
    }
    function added(file){
      if(closed||!file) return;
      current=file;failed=false;resetClock();schedule();
      if(watched.has(file)) return;
      watched.add(file);
      file.progress?.(()=>{if(!closed&&current===file){resetClock();schedule();}});
      file.done?.(()=>{if(!closed&&current===file){resetClock();schedule();}});
      file.fail?.(()=>{if(!closed&&current===file){failed=true;env.clearTimeout(stallTimer);schedule();}});
    }
    function removed(file){
      if(file!==current) return;
      current=null;failed=false;slow=false;env.clearTimeout(stallTimer);schedule();
    }
    function click(event){
      const target=event.target.closest?.('[data-pp-upload-chat],[data-pp-upload-retry]');
      if(!target||!panel?.contains(target)) return;
      if(target.hasAttribute('data-pp-upload-chat')) return chat(event,dialog);
      event.preventDefault();
      const native=root.querySelector('.uploadcare--error .uploadcare--preview__back');
      if(native&&!native.disabled){native.click();return;}
      collection.clear();dialog.switchTab('file');
    }
    function close(){
      if(closed) return;
      closed=true;env.clearTimeout(bootstrap);env.clearTimeout(stallTimer);env.cancelAnimationFrame(frame);
      observer?.disconnect();root?.removeEventListener('click',click);root?.removeEventListener('load',schedule,true);root?.removeEventListener('error',schedule,true);
      collection.onAdd.remove(added);collection.onRemove.remove(removed);removePanel();
    }
    function bind(attempt=0){
      if(closed) return;
      root=doc.querySelector('.uploadcare--dialog_status_active:not(.uploadcare--dialog_status_inactive)');
      if(!root){if(attempt<20) bootstrap=env.setTimeout(()=>bind(attempt+1),50);return;}
      root.addEventListener('click',click);root.addEventListener('load',schedule,true);root.addEventListener('error',schedule,true);
      observer=new env.MutationObserver(schedule);inspect();
    }
    collection.onAdd.add(added);collection.onRemove.add(removed);
    dialog.always(close);bind();
    for(const file of collection.get()) added(file);
    return close;
  }
  return {watch,chat};
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-uploadly-polish"] && !Shopify.designMode) return;
  try {
    (function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else root.PPUploadPolish = factory(root);
})(typeof window !== 'undefined' ? window : this, function (env) {
  'use strict';
  const doc = env.document;
  const keyboardBound = new WeakSet();
  const guides = new WeakMap();
  let guideSequence = 0;
  const words = () => doc.getElementById('pp-uploadly-polish-text')?.dataset;
  function setText(node, text) { if (node && text && node.textContent !== text) node.textContent = text; }
  function orientation(ratio) {
    const match = /^(\d+):(\d+)$/.exec(ratio || '');
    if (!match || +match[1] < 1 || +match[2] < 1) return null;
    return +match[1] === +match[2] ? 'square' : +match[1] > +match[2] ? 'landscape' : 'portrait';
  }
  function size(bytes) {
    const value = Number(bytes);
    if (!Number.isSafeInteger(value) || value <= 0) return '';
    if (value < 1000) return value + ' B';
    const divisor = value < 1000000 ? 1000 : 1000000;
    return (Math.round(value / divisor * 10) / 10).toLocaleString(doc.documentElement.lang || 'en-GB') + (divisor === 1000 ? ' KB' : ' MB');
  }
  function labels(root, text) {
    if (!text) return;
    root.querySelectorAll('.uploadcare--panel__done').forEach(node => setText(node, text.usePhoto));
    const cropping = Boolean(root.querySelector('.uploadcare--crop-sizes__item[data-caption]'));
    root.querySelectorAll('.uploadcare-tab-effects--done').forEach(node => setText(node, cropping ? text.applyCrop : text.usePhoto));
    root.querySelectorAll('.uploadcare--crop-sizes__item[data-caption]').forEach(node => {
      const label = text[orientation(node.getAttribute('data-caption'))];
      if (!label) return;
      // The native ratio is also used by automatic orientation. Never replace it.
      if (node.dataset.ppOrientation !== label) node.dataset.ppOrientation = label;
      if (node.getAttribute('aria-label') !== label) node.setAttribute('aria-label', label);
    });
  }
  function guide(root) {
    const candidate = root.querySelector('.uploadcare--tab_current .uploadcare--preview__content_crop');
    const header = candidate?.querySelector('.uploadcare--jcrop-holder') ? root.querySelector('.uploadcare--tab_current .uploadcare--tab__header') : null;
    const existing = guides.get(root);
    if (existing && (existing.header !== header || !existing.element.isConnected)) { existing.dispose(); guides.delete(root); }
    if (header) setText(header.querySelector?.('.uploadcare--tab__title'), words()?.cropTitle);
    if (!header || guides.has(root)) return;
    const template = doc.getElementById('pp-uploadly-crop-guide-template');
    if (!template?.content) return;
    const element = template.content.firstElementChild.cloneNode(true);
    const trigger = element.querySelector('.pp-uploadly-crop-help__trigger');
    const popup = element.querySelector('dialog');
    if (typeof popup.showModal !== 'function') return;
    popup.id = 'pp-crop-help-' + (++guideSequence);
    const title = element.querySelector('.pp-uploadly-crop-help__title');
    title.id = popup.id + '-title';
    popup.setAttribute('aria-labelledby', title.id);
    trigger.setAttribute('aria-controls', popup.id);
    let disposed = false;
    function closeHelp(restoreFocus = true) {
      if (popup.open) popup.close();
      trigger.setAttribute('aria-expanded', 'false');
      env.removeEventListener('keydown', keydown, true);
      if (restoreFocus && !disposed && trigger.isConnected) trigger.focus({preventScroll: true});
    }
    function keydown(event) {
      if (event.key !== 'Escape' || !popup.open) return;
      event.preventDefault(); event.stopImmediatePropagation(); closeHelp();
    }
    trigger.addEventListener('click', event => {
      event.stopPropagation();
      popup.showModal(); trigger.setAttribute('aria-expanded', 'true');
      env.addEventListener('keydown', keydown, true);
    });
    popup.addEventListener('click', event => {
      event.stopPropagation();
      const bounds = popup.getBoundingClientRect();
      const outside = event.target === popup && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom);
      if (outside || event.target.closest('.pp-uploadly-crop-help__close')) closeHelp();
    });
    popup.addEventListener('cancel', event => { event.preventDefault(); event.stopPropagation(); closeHelp(); });
    popup.addEventListener('close', () => { if (!popup.open) closeHelp(false); });
    header.classList.add('pp-uploadly-crop-help-heading');
    header.append(element);
    guides.set(root, {header, element, dispose() { disposed = true; closeHelp(false); element.remove(); header.classList.remove('pp-uploadly-crop-help-heading'); }});
  }
  function watch(dialog) {
    if (typeof dialog?.always !== 'function' || !words()) return () => {};
    let root, observer, timer, frame = 0, closed = false;
    function refresh() {
      frame = 0;
      if (closed) return;
      observer.disconnect();
      labels(root, words());
      guide(root);
      observer.observe(root, {childList: true, subtree: true, characterData: true});
    }
    function schedule() { if (!closed && !frame) frame = env.requestAnimationFrame(refresh); }
    function close() {
      if (closed) return;
      closed = true; observer?.disconnect(); env.clearTimeout(timer); env.cancelAnimationFrame(frame);
      guides.get(root)?.dispose(); guides.delete(root);
    }
    function bind(attempt = 0) {
      if (closed) return;
      root = doc.querySelector('.uploadcare--dialog_status_active:not(.uploadcare--dialog_status_inactive)');
      if (!root) { if (attempt < 20) timer = env.setTimeout(() => bind(attempt + 1), 50); return; }
      observer = new env.MutationObserver(schedule); refresh();
    }
    dialog.always(close); bind(); return close;
  }
  function card(field, marker) {
    const text = words();
    if (!field || !marker || !text) return;
    field.querySelectorAll('[data-prev-id]').forEach(wrapper => {
      const image = wrapper.querySelector('img[data-open-dialog]');
      if (!image) return;
      wrapper.classList.add('pp-uploadly-photo-card');
      image.alt = text.photoPreview;
      const remove = [...wrapper.children].find(node => node.tagName === 'DIV' && node.querySelector('svg'));
      if (remove) {
        remove.classList.add('pp-uploadly-photo-remove');
        remove.setAttribute('role', 'button'); remove.setAttribute('tabindex', '0'); remove.setAttribute('aria-label', text.removePhoto);
        if (!keyboardBound.has(remove)) {
          keyboardBound.add(remove);
          remove.addEventListener('keydown', event => {
            if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); event.stopPropagation(); remove.click(); }
          });
        }
      }
      let meta = wrapper.querySelector('.pp-uploadly-photo-meta');
      if (!meta) {
        meta = doc.createElement('div'); meta.className = 'pp-uploadly-photo-meta';
        const name = doc.createElement('p'), bytes = doc.createElement('p');
        name.className = 'pp-uploadly-photo-name'; bytes.className = 'pp-uploadly-photo-size';
        meta.append(name, bytes); wrapper.append(meta);
      }
      const matched = marker.dataset.sourceUuid === wrapper.dataset.prevId && marker.dataset.cropSource && marker.dataset.printVerified === marker.dataset.cropSource;
      const filename = matched ? marker.dataset.filename : '';
      const bytes = matched ? size(marker.dataset.originalBytes) : '';
      meta.hidden = !filename && !bytes;
      const name = meta.querySelector('.pp-uploadly-photo-name'), filesize = meta.querySelector('.pp-uploadly-photo-size');
      name.textContent = filename || ''; name.hidden = !filename;
      filesize.textContent = bytes ? text.originalFile + ': ' + bytes : ''; filesize.hidden = !bytes;
    });
  }
  return {watch, card, labels, guide, orientation, size};
});
  } catch(e) { console.error(e); }
})();

})();
